import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import Modal from 'react-bootstrap4-modal';

import { ROUTES, insertIdtoUrl } from 'constants/Routes.js';

const DeleteModal = ({
  modalToggle,
  deleteName,
  businessCount,
  deleteId,
  questionCount,
  cancelDelete,
  confirmDeleteCategory,
}) => (
  <Modal visible={modalToggle} onClickBackdrop={cancelDelete}>
    <div className="modal-header">
      <h5 className="modal-title">Delete Survey Template </h5>
      <a href="#" onClick={cancelDelete} className="close-delete-popup">
        X
      </a>
    </div>
    <div className="modal-body">
      <p>Are you sure you want to delete the survey template{' '}
        <span className="font-weight-bold">{deleteName}</span>?
      </p>
      <div>
        <center>
          {`Total ${businessCount} ${
            businessCount <= 1 ? 'business is' : 'businesses are'
          } associated with ${deleteName}`}
          <NavLink to={insertIdtoUrl(ROUTES.BUSINESS_FILTER, deleteId)}>
            <br />
            <u>View All</u>
          </NavLink>
        </center>
      </div>
      <div>
        <center>
          {`Total ${questionCount} ${
            questionCount <= 1 ? 'question is' : 'questions are'
          } associated with ${deleteName}`}
          <NavLink to={insertIdtoUrl(ROUTES.CATEGORIES_QUESTIONS, deleteId)}>
            <br />
            <u>View All</u>
          </NavLink>
        </center>
      </div>
    </div>
    <div className="modal-footer">
      <button
        type="button"
        className="btn btn-secondary"
        onClick={cancelDelete}
      >
        Cancel
      </button>
      <button
        type="button"
        className="btn btn-primary"
        onClick={confirmDeleteCategory}
      >
        Delete
      </button>
    </div>
  </Modal>
);

DeleteModal.propTypes = {
  modalToggle: PropTypes.bool,
  deleteName: PropTypes.string,
  businessCount: PropTypes.number,
  deleteId: PropTypes.number,
  questionCount: PropTypes.number,
  cancelDelete: PropTypes.func,
  confirmDeleteCategory: PropTypes.func,
};

export default DeleteModal;



// WEBPACK FOOTER //
// ./src/components/surveyTemplate/DeleteModal.js